<!-- Dummy element for autofocus -->
@if (currentGeneralData) {
  <div class="modal-wrapper" [class.st-drawer-in-mobile]="!!drawerRef">
    <!-- Header -->
    <div class="st-modal-header">
      <p>{{currentGeneralData.title}}</p>
      <button class="flex-center" nz-button [nzSize]="(isMobile$ | async) ? 'default' : 'large'" nzType="text"
              nzShape="circle" (click)="close()">
        <app-st-icon [bold]="true" name="close"></app-st-icon>
      </button>

    </div>

    <!-- Content -->
    <div class="st-modal-content">
        @switch (docModalType) {

          <!-- Upload -->
          @case ('upload') {

            @if (aiUploadMode) {
              <p class="info-text">
                @if (aiDocumentTypeMissing) {
                  El análisis con IA solo lee el BL (Conocimiento de Embarque) y ese tipo de documento no está disponible. Usa «Subir sin IA».
                } @else {
                  El análisis con IA solo lee el BL (Conocimiento de Embarque). Para cualquier otro documento usa «Subir sin IA».
                }
              </p>
            }

            <!-- Upload Component -->
            <ng-container [ngTemplateOutlet]="nzUploadTmpl"></ng-container>

            <!-- Mostrar la lista de formularios para que el usuario seleccione el tipo de documento para cada archivo -->
            <ng-container [ngTemplateOutlet]="uploadListTmpl"></ng-container>

          }

          <!-- Correct -->
          @case ('correct') {

            <!-- Upload Component -->
            <ng-container [ngTemplateOutlet]="nzUploadTmpl"></ng-container>

            <!-- Mostrar la lista de formularios para que el usuario seleccione el tipo de documento para cada archivo -->
            <ng-container [ngTemplateOutlet]="uploadListTmpl"></ng-container>

            <!-- Documento a corregir -->
            <div class="correct-doc-wrapper">
              <p>Se va a reemplazar el siguiente documento:</p>
              <div>
                <div>
                  <app-st-icon [color]="'#8F8F8F'" [avatar]="true" [bold]="true" name="scan_delete"></app-st-icon>
                  <div class="doc-info flex">
                  <strong>{{document!.type}}</strong>
                  <span>·</span>
                  <label>{{document!.name}}</label>
                  </div>
                </div>

                <app-st-icon [bold]="true" name="arrow_forward"></app-st-icon>

                <div>
                  <app-st-icon [color]="'#666666'" [avatar]="true" [bold]="true" name="description"></app-st-icon>
                  <div class="doc-info flex">
                  <strong>{{document!.type}}</strong>
                  <span>·</span>
                  <label>{{uploadForms.length > 0 ? uploadForms[0].file.name : '-'}}</label>
                  </div>
                </div>
              </div>
            </div>

          }

          <!-- Validate -->
          @case ('validate') {
            <div  class="flex flex-column gap-200">
              <p class="info-text">
                ¿Estás seguro que quieres validar el documento? Podrás rechazarlo o volver a pendiente de validación más adelante si lo necesitas.</p>

              <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: document }"></ng-container>
            </div>
          }

          <!-- Reject -->
          @case ('reject') {
            <div class="flex flex-column gap-200">
              <p class="info-text">¿Estás seguro que quieres rechazar el documento? Tendrá que volver a subirse.</p>
              <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: document }"></ng-container>
              <p class="info-text">Para garantizar que se vuelva a subir el documento con los requisitos, es necesario detallar a continuación los motivos del rechazo.</p>
              <span class="text-label-10">Motivo</span>
              <textarea [(ngModel)]="rejectReason" rows="4" nz-input class="info-text"
                        placeholder="El documento no es válido porque..."></textarea>
            </div>
          }

          <!-- Return -->
          @case ('return') {
            <div  class="flex flex-column gap-200">
              <p class="info-text">
                ¿Quieres volver a marcar el documento como pendiente de validación? El validador tendrá que volver a validar el documento.</p>

              <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: document }"></ng-container>

  <!--            <p class="info-text">Para garantizar que se vuelva a subir el documento con los requisitos, es necesario detallar a continuación los motivos del rechazo.</p>-->
  <!--            <span class="text-label-10">Motivo</span>-->
  <!--            <textarea [(ngModel)]="rejectReason" rows="4" nz-input class="info-text"-->
  <!--                      placeholder="El documento no es válido porque..."></textarea>-->
            </div>
          }

          <!-- Delete -->
          @case ('delete') {
            <p class="info-text">
              ¿Estás seguro que desea eliminar {{ documentsToDelete!.length > 1 ? 'los documentos' : 'el documento' }}? </p>
            <br>
            <p style="margin-right: 15px; margin-bottom: 12px" class="info-text">
              Esta operación es irreversible y {{ documentsToDelete!.length > 1 ? 'los documentos no se podrán' : 'el documento no se podrá' }} recuperar.</p>
            @if (documentsToDelete!.length > 1) {
              <div class="flex flex-column gap-200">
                @for (doc of documentsToDelete; track doc.id) {
                  <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: doc }"></ng-container>
                }
              </div>
            }

          }
          @default {
            <p>No tenemos este tipo de Modal.</p>
          }
        }
    </div>


    <!-- Footer -->
    <div class="st-modal-footer">
      @if (!drawerRef) {
        <button nz-button nzSize="large" nzType="text" nzShape="round" (click)="close()">
          Cancelar
        </button>
      }

      <button nz-button nzSize="large" nzType="primary" nzShape="round" class="flex-center"
              (click)="onConfirm()" [nzDanger]="docModalType === 'delete'"
              [disabled]="(docModalType === 'upload' || docModalType === 'correct') ? !allFormsValid
                            : ((docModalType !== 'return' && docModalType !== 'validate' && docModalType !== 'delete') ? !rejectReason : false)">
        @if (!!currentGeneralData!.actionIcon && !loading) {
<app-st-icon style="margin-right: 8px" [bold]="true"
          [name]="currentGeneralData!.actionIcon"></app-st-icon>
        }
        @if (loading) {
          <app-st-icon style="margin-right: 8px" name="progress_activity"></app-st-icon>
        }
        <span>{{currentGeneralData!.actionTitle}}</span>
      </button>
    </div>
  </div>
}

<ng-template #notificationTmpl>
  @if (notRef) {
<app-toast [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
    [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
  }
</ng-template>

<ng-template #nzUploadTmpl>
  <nz-upload
    #uploadComponent
    nzType="drag"
    [attr.accept]="uploadAccept"
    [nzShowUploadList]="false"
    [nzMultiple]="!document && !isMultipleSOMode"
    [nzCustomRequest]="customUpload"
    (nzChange)="handleUploadChange($event)"
  >
    <div class="ant-upload-drag-icon">
      <app-st-icon [bold]="true" name="upload"></app-st-icon>
    </div>
    <p class="ant-upload-text">{{ (isMobile$ | async) ? 'Pulsa para subir documentos.' : 'Arrastra a esta ventana o haz click para subir documentos.' }}</p>
  </nz-upload>
</ng-template>

<ng-template #uploadListTmpl>
  <!-- Modo múltiple SO -->
  @if (isMultipleSOMode && singleFile) {
    <div class="upload-list-wrapper">
      <!-- Primera fila: documento global (no eliminable) -->
      <div>
        <nz-card>
          <app-st-icon [avatar]="true" [bold]="true" name="description"></app-st-icon>
          <span>{{singleFile.name}}</span>
        </nz-card>

        @if (!onlyReturnFiles) {
          <div class="select-wrapper">
            <nz-select class="larger" [(ngModel)]="globalDocumentType" [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                       [nzDisabled]="!!aiDocumentType" [nzSuffixIcon]="customSelectIcon1" nzShowSearch
                       nzPlaceHolder="Selecciona el tipo de documento"
                       (ngModelChange)="updateGlobalDocumentType($event)">
              @for (opt of documentTypes; track opt) {
                <nz-option [nzLabel]="opt.name" [nzValue]="opt.name"></nz-option>
              }
              <ng-template #customSelectIcon1>
                <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
              </ng-template>
            </nz-select>
            <span nz-tooltip="Modifique todos los tipos de documentos. Todavía se puede modificar individualmente.">
              Tipo de documento de todas las OS
            </span>
          </div>
        }

        @if (!onlyReturnFiles) {
          <div class="select-wrapper partner-select">
            <nz-date-picker class="larger" [(ngModel)]="globalExpirationDate"
                            [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                            nzFormat="dd-MM-yyyy"
                            nzPlaceHolder="Selecciona la fecha de expiración"
                            (ngModelChange)="updateGlobalExpirationDate($event)"
            ></nz-date-picker>
            <span nz-tooltip="Modifique todas las fechas de expiración. Todavía se puede modificar individualmente.">
              Fecha de exp. de todas las OS
            </span>
          </div>
        }

        <button nz-button nzSize="large" class="larger" nzType="text" nzShape="circle"
                style="visibility: hidden"
                nzDanger>
          <app-st-icon [bold]="true" name="delete"></app-st-icon>
        </button>
      </div>

      <!-- Filas de SOs -->
      @for (soData of serviceOrderUploadData; track soData.serviceOrder.id) {
        <div>
          <nz-card>
            <app-st-icon [avatar]="true" [bold]="true" name="checklist"></app-st-icon>
            @if (soData.status === 'pending') {
              <span>{{soData.serviceOrder.reference}}</span>
            }
            @if (soData.status !== 'pending') {
              <nz-progress nzType="line" [nzShowInfo]="false" nzSize="default"
                           [nzStrokeWidth]="4" [nzPercent]="soData.progress"
                           [nzStrokeColor]="soData.status === 'uploading' ? '#0068D6'
                                                      : (soData.status === 'success' ? '#45DEC5' : '#DA2F35')"
              ></nz-progress>
            }
          </nz-card>

          @if (!onlyReturnFiles) {
            <div class="select-wrapper">
              <nz-select class="larger" [(ngModel)]="soData.documentType" [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                         [nzDisabled]="!!aiDocumentType" [nzSuffixIcon]="customSelectIcon2" nzShowSearch
                         nzPlaceHolder="Selecciona el tipo de documento"
                         (ngModelChange)="updateSODocumentType(soData, $event)">
                @for (opt of documentTypes; track opt) {
                  <nz-option [nzLabel]="opt.name" [nzValue]="opt.name"></nz-option>
                }
                <ng-template #customSelectIcon2>
                  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
                </ng-template>
              </nz-select>
              <span>Tipo de documento</span>
            </div>
          }

          @if (!onlyReturnFiles) {
            <div class="select-wrapper partner-select">
              <nz-date-picker class="larger" [(ngModel)]="soData.expirationDate"
                              [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                              nzFormat="dd-MM-yyyy"
                              nzPlaceHolder="Selecciona la fecha de expiración"
                              (ngModelChange)="updateSOExpirationDate(soData, $event)"
              ></nz-date-picker>
              <span>Fecha de expiración</span>
            </div>
          }

          <button nz-button nzSize="large" class="larger" nzType="text" nzShape="circle" (click)="deleteSOFromUpload(soData)" nzDanger>
            <app-st-icon [bold]="true" name="delete"></app-st-icon>
          </button>
        </div>
      }
    </div>
  }

  <!-- Modo normal -->
  @if (!isMultipleSOMode && uploadForms.length > 0) {
    <div class="upload-list-wrapper">
      @for (form of uploadForms; track form.file.name) {
        <div>
          <nz-card>
            <app-st-icon [avatar]="true" [bold]="true" name="description"></app-st-icon>
            @if (form.status === 'pending') {
              <span>{{form.file.name}}</span>
            }
            @if (form.status !== 'pending') {
              <nz-progress nzType="line" [nzShowInfo]="false" nzSize="default"
                           [nzStrokeWidth]="4" [nzPercent]="form.progress"
                           [nzStrokeColor]="form.status === 'uploading' ? '#0068D6'
                                                      : (form.status === 'success' ? '#45DEC5' : '#DA2F35')"
              ></nz-progress>
            }
          </nz-card>

          @if (!onlyReturnFiles) {
            <div class="select-wrapper">
              <nz-select class="larger" [(ngModel)]="form.documentType" [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                         [nzDisabled]="!!document || !!documentType || !!aiDocumentType" [nzSuffixIcon]="customSelectIcon3" nzShowSearch
                         nzPlaceHolder="Selecciona el tipo de documento">
                @for (opt of documentTypes; track opt) {
                  <nz-option [nzLabel]="opt.name" [nzValue]="opt.name"></nz-option>
                }
                <ng-template #customSelectIcon3>
                  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
                </ng-template>
              </nz-select>
              <span>Tipo de documento</span>
            </div>
          }

          @if (!onlyReturnFiles) {
            <div class="select-wrapper partner-select">
              <nz-date-picker class="larger" [(ngModel)]="form.expirationDate"
                              [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                              nzFormat="dd-MM-yyyy"
                              nzPlaceHolder="Selecciona la fecha de expiración"
              ></nz-date-picker>

              <span>Fecha de expiración</span>
            </div>
          }

          <button nz-button nzSize="large" class="larger" nzType="text" nzShape="circle" (click)="deleteDocumentToUpload(form)" nzDanger>
            <app-st-icon [bold]="true" name="delete"></app-st-icon>
          </button>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #docNameTmpl let-document>
  <div class="doc-name">
    <app-st-icon [color]="'#666666'" [avatar]="true" [bold]="true" name="description"></app-st-icon>
    <div class="doc-info flex">
      <strong>{{document!.type}}</strong>
      <span>·</span>
      <label class="text-nowrap">{{document!.name}}</label>
    </div>
  </div>
</ng-template>




